export default "/assets/images/filter-big-sneeze-box.4a1b37ad06d52e81.png";